// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vme-supplier__card[data-v-83474ec4]{min-height:500px}.vme-supplier__iframe[data-v-83474ec4]{border:0}[data-v-83474ec4] .v-list-item__content,[data-v-83474ec4] .vme-supplier__container td:not([align=right]){text-align:left}[data-v-83474ec4] .vme-supplier__container pre{white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
